import httpClient from '~/http';
import { PrintServerFormValues, PrintServerItem } from './types';

export const fetchPrintServer = () => {
  return httpClient.get<PrintServerItem>('/api/v2/print-servers');
};

export const upsertPrintServer = (values: PrintServerFormValues) => {
  return httpClient.post('/api/v2/print-servers', values);
};
